<template>
  <div class="protocolli-sicurezza">
    <div class="offset-2 col-20">
      <el-table v-loading="loading" class="custom-table"
        :data="protocolli">
        <el-table-column
          prop="idDoc"
          :label="$t('protocolliSicurezza.idDoc')"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="versione"
          align="center" header-align="center"
          :label="$t('protocolliSicurezza.versione')"
          min-width="80">
        </el-table-column>
        <el-table-column
          prop="desc"
          :label="$t('protocolliSicurezza.descrizione')"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="lingua"
          align="center" header-align="center"
          :label="$t('protocolliSicurezza.lingua')"
          min-width="80">
        </el-table-column>
        <el-table-column
          align="center"
          width="40">
          <template slot-scope="scope">
            <div class="name-wrapper">
              <el-tooltip class="item" effect="dark" :content="$t('protocolliSicurezza.download')" placement="top-start">
                <icon name="riv-pdf_RGB" scale="1.5" @click.native.stop="downloadDoc(scope.row)" class="pointer" />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="checkbox col-24" v-show="(protocolli.length > 0)">
      <div class="col-24">
        {{ $t('protocolliSicurezza.protocolloSicurezza') }}
      </div>
      <div class="col-24">
        <el-checkbox class="custom-checkbox" v-model="checked">{{ $t('protocolliSicurezza.protocolloSicurezza2') }}</el-checkbox>
      </div>
    </div>
    <div class="button col-22 offset-1">
      <el-button class="custom-button" @click="back">{{$t('protocolliSicurezza.indietro').toUpperCase()}}</el-button>
      <el-button class="custom-button" type="primary" @click="avanti" 
        :disabled="(saved.ifProtSic === 'Y' && !checked)"
      >
        {{ $t('protocolliSicurezza.avanti').toUpperCase() }}
      </el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProtocolliSicurezza',
    props: ['form', 'saved'],
    filters: {
      formatString: function (string) {
        if (string === '') {
          return ' '
        }
        return string
      }
    },
    data () {
      return {
        protocolli: [],
        checked: false,
        codLang: sessionStorage.hasOwnProperty('codLang') ? sessionStorage.getItem('codLang') : 'it_IT',
        loading: true
      }
    },
    i18n: {
      messages: {
        it_IT: {
          protocolliSicurezza: {
            nrProt: 'Nr. Pro',
            idDoc: 'ID Documento',
            nrRif: 'Nr. Riferimento',
            versione: 'Versione',
            descrizione: 'Descrizione',
            lingua: 'Lingua',
            download: 'Download',
            protocolloSicurezza: 'Protocollo di Sicurezza con l\'obbligo di trasferire anche ad aventuali subfornitori',
            protocolloSicurezza2: 'Ho preso visione',
            avanti: 'Avanti',
            indietro: 'Indietro'
          }
        },
        fr_FR: {
          protocolliSicurezza: {
            nrProt: 'Nr. Pro',
            idDoc: 'ID Document',
            nrRif: 'N. référence',
            versione: 'Version',
            descrizione: 'Description',
            lingua: 'Langue',
            download: 'Download',
            protocolloSicurezza: 'Protocole de sécurité avec obligation de le transmettre également à tous les sous-traitants',
            protocolloSicurezza2: 'J\'ai vu',
            avanti: 'Suivant',
            indietro: 'Precedent'
          }
        },
        es_ES: {
          protocolliSicurezza: {
            nrProt: 'Nr. Pro',
            idDoc: 'ID Documento',
            nrRif: 'N. Referencia',
            versione: 'Versión',
            descrizione: 'Descripción',
            lingua: 'Idioma',
            download: 'Download',
            protocolloSicurezza: 'Protocolo de seguridad obligatorio también para subproveedores',
            protocolloSicurezza2: 'Yo he visto',
            avanti: 'Adelante',
            indietro: 'Atrás'
          }
        },
        de_DE: {
          protocolliSicurezza: {
            nrProt: 'Pro. Nr.',
            idDoc: 'Dokument Nr.',
            nrRif: 'Bezug Nr.',
            versione: 'Version',
            descrizione: 'Beschreibung',
            lingua: 'Sprache',
            download: 'Download',
            protocolloSicurezza: 'Sicherheitshinweise akzeptiert(auch für Unterlieferanten)',
            protocolloSicurezza2: 'Ich habe es gesehen',
            avanti: 'Vorwärts',
            indietro: 'Zurück'
          }
        },
        en_GB: {
          protocolliSicurezza: {
            nrProt: 'Nr. Pro',
            idDoc: 'ID Document',
            nrRif: 'N. Reference',
            versione: 'Version',
            descrizione: 'Description',
            lingua: 'Lang.',
            download: 'Download',
            protocolloSicurezza: 'Security protocol with the obligation of trasmitting it also to any subcontractors',
            protocolloSicurezza2: 'I have seen',
            avanti: 'Next',
            indietro: 'Back'
          }
        }
      }
    },
    mounted: function () {
      this.getProtocolli()
      this.checked = (this.saved.protSicur === 'S')
    },
    methods: {
      downloadDoc: function (protocollo) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringRottame + 'download/protocollosicurezza' +
                '?idCli=' + protocollo.idCli +
                '&idApp=' + protocollo.idApp +
                '&keyDoc=' + protocollo.keyDoc +
                '&nome=' + protocollo.nome + '_' + protocollo.lingua +
                '&token=' + response.body.wsToken
              )
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      back: function () {
        this.$emit('indietro')
      },
      avanti: function () {
        this.$emit('avanti', 1, {
          protSicur: (this.checked) ? 'S' : 'N',
          ifProtSic: this.saved.ifProtSic
        })
      },
      getProtocolli: function () {
        this.$http.get('buonidiscarico/protocollisicurezza', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codSoc: this.form.stab.codSoc,
            codStab: this.form.stab.codStab
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'protocolli', response.body.data)
            } else {
              this.$set(this, 'protocolli', [])
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.loading = false
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .protocolli-sicurezza {
    .checkbox {
      margin-top: 40px;
      text-align: center;
    }
    .button {
      margin-top: 10px;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneRottame/ProtocolliSicurezza.vue